// Text styles
export const regularGrayText = '#696969';
export const lightGrayText = '#8c8c8c';
export const regularYellowText = '#e1a913';
export const headerBlueText = '#2d4066';
export const linkBlueText = '#1c487e';
export const paragraphFontFamilies = '"acumin-pro", Arial, Helvetica, sans-serif';

// Button styles
export const buttonBlueBackground = '#1c487e';
export const buttonBlueBackgroundHover = '#194979';

//  Border styles
export const borderGrayOutline = '#e1e1e1';
export const borderGrayOutlineLight = '#ededed';
